import { Field, Label } from '@/components/ui/catalyst/fieldset';
import { Input } from '@/components/ui/catalyst/input';
import { Select } from '@/components/ui/catalyst/select';
import { Textarea } from '@/components/ui/catalyst/textarea';

import { ChannelFormData, FormErrors, MAJOR_VENDORS } from './types';

interface CompactBasicInfoSectionProps {
  formData: ChannelFormData;
  errors: FormErrors;
  onChange: (field: keyof ChannelFormData, value: string) => void;
}

const getContactPlaceholder = (handleType: string): string => {
  switch (handleType) {
    case 'PHONE':
      return '(555) 123-4567';
    case 'EMAIL':
      return 'records@pd.gov';
    case 'WEBSITE':
      return 'https://portal.department.gov';
    case 'FAX':
      return '(555) 123-4568';
    default:
      return 'Contact value';
  }
};

export const CompactBasicInfoSection = ({
  formData,
  errors,
  onChange,
}: CompactBasicInfoSectionProps) => {
  const isMailingAddress = formData.handleType === 'MAILING_ADDRESS';
  const isWebsite = formData.handleType === 'WEBSITE';

  if (isMailingAddress) {
    return (
      <div className="space-y-4">
        <Field>
          <Textarea
            name="instructions"
            value={formData.instructions}
            onChange={(e) => onChange('instructions', e.target.value)}
            placeholder="How should requests be made by mail? Include any specific procedures or forms required..."
            rows={4}
            invalid={!!errors.instructions}
          />
        </Field>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <Field>
        <Textarea
          name="instructions"
          value={formData.instructions}
          onChange={(e) => onChange('instructions', e.target.value)}
          placeholder="Describe how to request records via this method..."
          rows={3}
          invalid={!!errors.instructions}
        />
      </Field>

      <div className="grid grid-cols-3 gap-3">
        <Field className="col-span-2">
          <Input
            value={formData.handleValue}
            onChange={(e) => onChange('handleValue', e.target.value)}
            placeholder={getContactPlaceholder(formData.handleType)}
          />
        </Field>

        <Field>
          <Input
            value={formData.handleName}
            onChange={(e) => onChange('handleName', e.target.value)}
            placeholder="Label (optional)"
          />
        </Field>
      </div>

      {isWebsite && (
        <Field>
          <Label className="text-xs font-medium text-gray-700">
            Portal Type
          </Label>
          <Select
            value={formData.majorVendor}
            onChange={(e) => onChange('majorVendor', e.target.value)}
          >
            {MAJOR_VENDORS.map((vendor) => (
              <option key={vendor.value} value={vendor.value}>
                {vendor.label}
              </option>
            ))}
          </Select>
        </Field>
      )}
    </div>
  );
};
